import { Card, FlexDiv, H1, H3, P } from 'components/generic/HomePageComponents'
import { TransitionImage } from './Styled'

const HowItWorksCard = ({ step, content: { description, title, imageUrl, imageAlt } }) => (
  <Card mr={{ _: '0px', tablet: '40px' }} width={{ _: '75vw', desktop: '33%' }} mb='35px'>
    <FlexDiv justifyContent='center'>
      <TransitionImage width='300px' src={imageUrl} alt={imageAlt} />
    </FlexDiv>
    <H3
      textAlign={{ _: 'center', tablet: 'left' }}
      color='inverseColor'
      mb='0px'
      fontWeight='700'
      fontSize='18px'
    >
      {step}
    </H3>
    <H1
      fontSize={{ _: '25px', desktop: '30px' }}
      lineHeight='30px'
      mb='10px'
      mt='0px'
      textAlign={{ _: 'center', tablet: 'left' }}
    >
      {title}
    </H1>
    <P
      fontSize={{ _: '18px', tablet: '20px', desktop: '22px' }}
      textAlign={{ _: 'center', tablet: 'left' }}
      maxWidth='none'
      mt='5px'
    >
      {description}
    </P>
  </Card>
)

export default HowItWorksCard
